// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"random-quote_quoteContainer_3hlIH","startQuote":"random-quote_startQuote_2ysaH","endQuote":"random-quote_endQuote_1PiuW"};